import { render, staticRenderFns } from "./ExtratoDeTransacao.vue?vue&type=template&id=798607a0"
import script from "./ExtratoDeTransacao.vue?vue&type=script&lang=js"
export * from "./ExtratoDeTransacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports